import type { AppLocale } from "../features/cv/types";

export const LOCALES: AppLocale[] = ["pt", "en"];
export const DEFAULT_LOCALE: AppLocale = "pt";
export const SITE_URL = "https://bennworks.pt";

export function parseLocale(raw?: string): AppLocale {
  return raw === "en" ? "en" : "pt";
}

export function swapLocalePath(pathname: string, next: AppLocale): string {
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length && LOCALES.includes(parts[0] as AppLocale)) parts[0] = next;
  else parts.unshift(next);
  return "/" + parts.join("/");
}
